import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      height: 338,
      width: '100%',
      borderRadius: 10,
      overflow: 'hidden',
      marginBottom: SMALL_MARGIN,
      background: theme.palette.secondary.light,
      position: 'relative',
    },
    infoWrap: {
      position: 'relative',
      padding: '0 24px 21px',
    },
    title: {
      fontSize: 16,
      lineHeight: 1.2,
      fontWeight: 'bold',
      marginBottom: 9,
      color: colorsPalette.white,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
      wordBreak: 'break-word',
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
    description: {
      fontSize: 14,
      lineHeight: 1.2,
      fontWeight: 'normal',
      color: colorsPalette.violet,
    },
    imageWrap: {
      width: '100%',
      height: 208,
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      '&::after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        height: '90%',
        background:
          'linear-gradient(0deg, rgba(35, 32, 46, 1) 0%, rgba(36, 34, 47, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat',
        '-webkit-background-origin': 'padding-box',
        '-o-background-origin': 'padding-box',
        '-moz-background-origin': 'padding-box',
      },
      '&:hover > img': {
        height: '110%',
      },
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'height .3s ease',
    },
    playIconWrap: {
      position: 'absolute',
      width: 64,
      height: 64,
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 5,
      borderRadius: '50%',
      background: 'rgba(29, 29, 41, 0.501961)',
    },
    playIcon: {
      width: 28,
      height: 32,
      marginLeft: 6,
    },
    categoriesWrapper: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      '& > a:not(:last-child)': {
        marginRight: 9,
        marginBottom: 9,
      },
      '& > div': {
        marginRight: 9,
        marginBottom: 9,
        '&:last-child': {
          marginRight: 0,
        },
      },
      '&:not(:only-child)': {
        marginRight: 10,
      },
    },
    label: {
      position: 'absolute',
      top: 12,
      left: 12,
    },
    labelsWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      '& $cpdLabel': {
        padding: '4.5px 9px',
      },
    },
    cpdLabel: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
      padding: '4.5px 9px',
    },
    cpdScore: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      fontSize: 20,
      lineHeight: 1,
      [theme.breakpoints.up('xl')]: {
        marginRight: 9,
      },
    },
    cpdTitle: {
      display: 'none',
      color: colorsPalette.white,
      fontSize: 14,
      lineHeight: 1,
      whiteSpace: 'nowrap',
      [theme.breakpoints.up('xl')]: {
        display: 'block',
      },
    },
  }),
);

export default useStyles;
